<template>
  <div>
    <b-modal v-model="isCameraOpen" ref="PromoCode" id="modal-center" class="modal-validation" size="md"
      no-close-on-backdrop="false" no-close-on-esc="false" centered hide-footer>
      <div id="app" class="web-camera-container">
        <div class="camera-box" style="">
          <vue-web-cam ref="webcam" :device-id="deviceId" height="400" width="100%" @started="onStarted"
            @error="onError" @cameras="onCameras" />
        </div>
        <div class="camera-shoot"><button type="button" class="button" @click="onTakeSnapshot">
            <i class="material-icons">photo_camera</i>
          </button>
        </div>
        <!---->
      </div>
    </b-modal>
    <b-modal v-model="MSSLCheck.IsInMSSL" id="modal-center" class="modal-validation" size="md"
      no-close-on-backdrop="true" no-close-on-esc="true" centered hide-header hide-footer>
      <template v-slot:default>
        <p>
          {{MSSLCheck.Message}}
        </p>

        <br />
        <div class="modal-button-wrapper">
          <b-button variant="danger" @click="handleOk">OK</b-button>
        </div>
      </template>
    </b-modal>
    <b-modal v-model="OnbehalfCheck.IsInValid" id="modal-center" class="modal-validation" size="md"
                no-close-on-backdrop="true" no-close-on-esc="true" centered hide-header hide-footer>
        <template v-slot:default>
            <div>
                <button type="button" class="close" @click="closeModal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-header text-center">
                <label style="display: block; margin: 0 auto;"><b>{{OnbehalfCheck.Title}}</b></label>
            </div>
            <div class="modal-body">
                {{OnbehalfCheck.Message}}
            </div>
            <br />
            <div class="modal-button-wrapper">
                <b-button variant="danger" class="btn-lg btn-block" @click="closeModal">OK</b-button>
            </div>
        </template>
    </b-modal>
    <div class="row">
      <div v-if="!isNotList" class="col-lg-12">
        <div class="row">
          <div class="col-lg-12">
            <h4 class="onbehalf-header">On Behalf Details</h4>
          </div>
        </div>
        <div class="onbehalf-list">
          <div class="form-card">
            <div class="form-card-forms">
              <div class="row">
                <div class="col-lg-12">
                  <div class="onbehalf-button-add" @click="onAddOnbehalfClick()">
                    <span class="btn-text-left">
                      <i class="material-icons" style="font-size: 35px;">add_circle</i>
                    </span>
                    <span class="btn-text-right"> Add New On Behalf </span>
                  </div>
                </div>
              </div>
              <div class="onbehalf-list-wrap" v-show="vModel.OnBehalfList != null && vModel.OnBehalfList.length > 0">
                <div class="onbehalf-list-item" v-for="item in vModel.OnBehalfList"
                  v-bind:key="item.OnBehalfCustomerId">
                  <div class="row">
                    <div class="col-lg-8" @click="onSelectOnBehalfCustomer(item.OnBehalfCustomerId)">
                      <div class="onbehalf-detail-left">
                        <div class="onbehalf-name">{{item.Name}}</div>
                        <div class="onbehalf-idnumber">{{item.IdNumber}}</div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="onbehalf-detail-right">
                        <span @click="onAddOnbehalfClick(item.OnBehalfCustomerId)" style="color: red;">Edit </span>
                        <span @click="onDeleteOnBehalfCustomer(item.OnBehalfCustomerId)">
                          <i class="material-icons" style="font-size: 30px;">delete</i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="row pull-to-bottom">
            <div class="col-lg-12">
              <div class="submit-option">
                <div class="left-option">
                  <button type="button" @click="backFromOnBehalfList" class="btn submit-lefticon-btn">
                    <span class="left-icon">
                      <i class="material-icons">chevron_left</i>
                    </span>
                    <span class="btn-content">Back</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="isNotList" class="col-lg-12">
        <div class="row">
            <div class="col-lg-12">
                <h4 class="onbehalf-header" v-if="this.mode == 'Edit'">Edit On Behalf</h4>
                <h4 class="onbehalf-header" v-else-if="this.mode == 'Add'">Add New On Behalf</h4>
            </div>
        </div>
        <form @submit.prevent="onSubmitOnBehalf" novalidate>
          <div class="form-card" v-if="onBehalfModel.PaymentNetworkId != 2">
            <div class="form-card-forms">
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Full Name
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="Name" name="Name" autocomplete="off"
                      v-model="onBehalfModel.Name" data-vv-as="Full Name" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('Name') }" v-only-uppercase />
                    <div v-show="errors.has('Name')" class="help is-danger">
                      {{ errors.first('Name') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Contact No.
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="MobileContact" name="MobileContact"
                      v-only-uppercase autocomplete="off" v-model="onBehalfModel.MobileContact" data-vv-as="Contact No."
                      v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
                    <div v-show="errors.has('MobileContact')" class="help is-danger">
                      {{ errors.first('MobileContact') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Occupation
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="OccupationId" v-model="onBehalfModel.OccupationId"
                      data-vv-as="Occupation" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('OccupationId') }">
                      <option :value="null" disabled>Select Occupation
                      </option>
                      <option :key="item.Id" v-for="item in OccupationList" :value="item.Id">{{item.Text}}</option>
                    </select>
                    <div v-show="errors.has('OccupationId')" class="help is-danger">
                      {{ errors.first('OccupationId') }}</div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Nationality
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="NationalityId" v-model="onBehalfModel.NationalityId"
                      data-vv-as="Nationality" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('NationalityId') }" @change="onChangeNationality">
                      <option :value="null" disabled>Select Nationality
                      </option>
                      <option :key="item.Id" v-for="item in NationalityWithIdTypeList" :value="item.Id">{{item.Text}}
                      </option>
                    </select>
                    <div v-show="errors.has('NationalityId')" class="help is-danger">
                      {{ errors.first('NationalityId') }}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      ID Type
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="IdTypeId" v-model="onBehalfModel.IdTypeId"
                      data-vv-as="ID Type" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('IdTypeId') }" @change="onChangeIdType">
                      <option :value="null" disabled>Select ID Type
                      </option>
                      <option :key="item.Id" v-for="item in IdTypeList" :value="item.Id">{{item.Text}}</option>
                    </select>
                    <div v-show="errors.has('IdTypeId')" class="help is-danger">
                      {{ errors.first('IdTypeId') }}</div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      ID Number
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="IdNumber" name="IdNumber"
                      v-only-uppercase autocomplete="off" v-model="onBehalfModel.IdNumber" v-validate="'required'"
                      data-vv-as="ID Number"
                      :class="{'input': true, 'is-danger': errors.has('IdNumber') }" />
                    <div v-show="errors.has('IdNumber')" class="help is-danger">
                      {{ errors.first('IdNumber') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group">
                        <label for>
                            Date Of Birth
                            <span class="required">*</span>
                        </label>
                        <kendo-datepicker class="form-control" id="DateOfBirth" name="DateOfBirth"
                                          v-model="onBehalfModel.DateOfBirth" :format="'dd/MM/yyyy'" :max="maxDate"
                                          onkeydown="return false;" data-vv-as='Date Of Birth'
                                          :class="{'input': true, 'is-danger': errors.has('DateOfBirth') }">
                        </kendo-datepicker>
                        <div v-show="errors.has('DateOfBirth')" class="help is-danger">
                            {{ errors.first('DateOfBirth') }}
                        </div>
                        <div v-show="isDateOfBirthInvalid" class="help is-danger">
                          Age should be at least 18 years. Please enter a valid Date of Birth.
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Address
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="Address" name="Address" v-only-uppercase
                      autocomplete="off" v-model="onBehalfModel.Address" data-vv-as="Address" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('Address') }" />
                    <div v-show="errors.has('Address')" class="help is-danger">
                      {{ errors.first('Address') }}
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Employer Name
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="EmployerName" name="EmployerName"
                      autocomplete="off" v-model="onBehalfModel.EmployerName" data-vv-as="Employer Name"  v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('EmployerName') }"
                      v-only-uppercase />
                    <div v-show="errors.has('EmployerName')" class="help is-danger">
                      {{ errors.first('EmployerName') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">

              </div>
              <div class="row">
                  <div class="col-lg-6" v-if="selectedIdType.IsFrontImageRequired">
                      <label>
                          ID Front
                          <span class="required" style="color:#c21c2b !important">*</span>
                      </label>
                      <div class="img-canvas">
                          <span class="img-icon-camera" v-if="onBehalfModel.IdFrontImage != null">
                              <img :src="'data:image/png;base64, '+onBehalfModel.IdFrontImage" />

                          </span>
                          <span class="img-icon-camera" v-else>
                              <img :src="IdFrontImageForDisplay" alt="">
                              <i class="material-icons">photo_camera</i>
                          </span>
                      </div>
                      <input type="hidden" class="form-control text-uppercase"
                             :required="selectedIdType.IsFrontImageRequired"
                             id="IdFrontImage" name="IdFrontImage"
                             autocomplete="off" v-model="onBehalfModel.IdFrontImage" data-vv-as="ID Front Image"
                             :class="{'input': true, 'is-danger': errors.has('IdFrontImage') }" />
                      <div v-show="errors.has('IdFrontImage')" class="help is-danger">
                          {{ errors.first('IdFrontImage') }}
                      </div>
                      <div class="button-group file-button-wrapper">
                          <button type="button" class="btn btn-danger take-snap-button" @click="onOpenCamera('FRONT')">
                              Take a
                              Picture
                          </button>
                          <button type="button" class="btn btn-danger take-snap-button" @click="onUploadImage('FRONT')">
                              Upload Image
                          </button>
                          <label for="FrontImage" style="display:none">
                              <div>Upload Image</div>
                              <input type="file" id="FrontImage" accept="image/png, image/jpeg, image/tiff" name="FrontImage"
                                     ref="uploadFrontImage" @change="onChangeFrontImage">
                          </label>
                      </div>
                  </div>
                  <div class="col-lg-6" v-if="onBehalfModel.IdBackImage != null || selectedIdType.IsBackImageRequired">
                      <label>
                          ID Back
                          <span class="required" style="color:#c21c2b !important">*</span>
                      </label>
                      <div class="img-canvas">
                          <span class="img-icon-camera" v-if="onBehalfModel.IdBackImage != null">
                              <img :src="'data:image/png;base64, '+onBehalfModel.IdBackImage" />

                          </span>
                          <span class="img-icon-camera" v-else>
                              <img :src="IdBackImageForDisplay" alt="">
                              <i class="material-icons">photo_camera</i>
                          </span>
                      </div>
                      <input type="hidden" class="form-control text-uppercase" id="IdBackImage" name="IdBackImage"
                             autocomplete="off"
                             :required="selectedIdType.IsBackImageRequired"
                             v-model="onBehalfModel.IdBackImage" data-vv-as="ID Back Image"
                             :class="{'input': true, 'is-danger': errors.has('IdBackImage') }" />
                      <div v-show="errors.has('IdBackImage')" class="help is-danger">
                          {{ errors.first('IdBackImage') }}
                      </div>
                      <div class="button-group file-button-wrapper">
                          <button type="button" class="btn btn-danger take-snap-button" @click="onOpenCamera('BACK')">
                              Take a
                              Picture
                          </button>
                          <button type="button" class="btn btn-danger take-snap-button" @click="onUploadImage('BACK')">
                              Upload Image
                          </button>
                          <label for="BackImage" style="display:none">
                              <div>Upload Image</div>
                              <input type="file" id="BackImage" accept="image/png, image/jpeg" name="BackImage"
                                     ref="uploadBackImage" @change="onChangeBackImage">
                          </label>
                      </div>

                  </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="round">
                    <input name="onBehalfDeclaration" id="onBehalfDeclaration"
                      data-vv-as="Please agree to terms and conditions to continue" v-validate="'required'"
                      type="checkbox" />
                    <label for="onBehalfDeclaration"></label>
                    <span class="pl-4">
                      I hearby declare that I am performing transaction(s) On behalf of the above name and confirm
                      that the information provided above is true and accurate.
                    </span>
                  </div>
                </div>
              </div>
              <div class="row onbehalf-add-button-row">
                <div class="col-lg-6">
                  <button type="button" class="btn btn-danger" @click="backFromOnBehalfAdd">BACK</button>
                </div>
                <div class="col-lg-6 save-button-wrapper">
                  <button type="submit" class="btn btn-danger">SAVE</button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-card" v-else>
            <div class="form-card-forms">
              <div v-if="onBehalfStep==1" class="row">
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      First Name
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="FirstName" name="FirstName" autocomplete="off"
                      v-model="onBehalfModel.FirstName" data-vv-as="First Name" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('FirstName') }" v-only-uppercase />
                    <div v-show="errors.has('FirstName')" class="help is-danger">
                      {{ errors.first('FirstName') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for="LastName">
                      Last Name
                      <span class="required">*</span>
                    </label>
                    <input type="text" key="LastName" class="form-control text-uppercase" id="LastName" name="LastName" autocomplete="off"
                      v-model="onBehalfModel.LastName" data-vv-as="Last Name" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('LastName') }" v-only-uppercase />
                    <div v-show="errors.has('LastName')" class="help is-danger">
                      {{ errors.first('LastName') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">

                  <div class="form-group">
                      <label for>
                        Contact No.
                        <span class="required">*</span>
                      </label>
                      <div class="input-group">

                        <select class="" style="text-align:center !important;" name="DialCode" v-model="onBehalfModel.DialCodeId"
                          data-vv-as="Dial Code" v-validate="'required'" @change="onWUOccupationChange"
                          :class="{'input': true, 'is-danger': errors.has('DialCode') }"
                          >
                          <option :value="null" disabled>Dial Code
                          </option>
                        <option :key="item.Id" v-for="item in DialCodeList" :value="item.Id">{{item.Text}}</option>
                        </select>

                        <input type="text" class="form-control text-uppercase" id="MobileContact" name="MobileContact"
                        v-only-uppercase autocomplete="off" v-model="onBehalfModel.MobileContact" data-vv-as="Contact No."
                        v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
                      </div>
                      <div v-show="errors.has('DialCode')" class="help is-danger">
                        {{ errors.first('DialCode') }}
                      </div>
                      <div v-show="errors.has('MobileContact')" class="help is-danger">
                        {{ errors.first('MobileContact') }}
                      </div>

                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Occupation
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="WUOccupationId" v-model="onBehalfModel.WUOccupationId"
                      data-vv-as="Occupation" v-validate="'required'" @change="onWUOccupationChange"
                      :class="{'input': true, 'is-danger': errors.has('WUOccupationId') }">
                      <option :value="null" disabled>Select Occupation
                      </option>
                      <option :key="item.Id" v-for="item in WUOccupationList" :value="item.Id">{{item.Text}}</option>
                    </select>
                    <div v-show="errors.has('WUOccupationId')" class="help is-danger">
                      {{ errors.first('WUOccupationId') }}</div>
                  </div>
                </div>
                <div class="col-lg-3" v-if="ShowEmploymentIndustry">
                  <div class="form-group">
                    <label for="">
                      Employment Industry<span class="required">*</span>
                    </label>
                    <div class="mb-3">
                      <select class="form-control classic" name="EmploymentIndustryId"
                        v-model="onBehalfModel.EmploymentIndustryId"  v-validate="'required'"
                         data-vv-as='Employment Industry'>
                        <option :value="null">Please Select Employment Industry</option>
                        <option v-for="option in EmploymentIndustries"
                          :key="option.Id" :value="option.Id">
                          {{option.Text}}
                        </option>
                      </select>
                      <div v-show="errors.has('EmploymentIndustryId')"
                        class="help is-danger">
                        {{ errors.first('EmploymentIndustryId') }}
                      </div>
                    </div>
                  </div>
												<!-- eo form group -->
								</div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Employer Name
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="EmployerName" name="EmployerName"
                      autocomplete="off" v-model="onBehalfModel.EmployerName" data-vv-as="Employer Name" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('EmployerName') }"
                      v-only-uppercase />
                    <div v-show="errors.has('EmployerName')" class="help is-danger">
                      {{ errors.first('EmployerName') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Nationality
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="NationalityId" v-model="onBehalfModel.NationalityId"
                      data-vv-as="Nationality" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('NationalityId') }" @change="onChangeNationality">
                      <option :value="null" disabled>Select Nationality
                      </option>
                      <option :key="item.Id" v-for="item in NationalityWithIdTypeList" :value="item.Id">{{item.Text}}
                      </option>
                    </select>
                    <div v-show="errors.has('NationalityId')" class="help is-danger">
                      {{ errors.first('NationalityId') }}</div>
                  </div>

                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Date Of Birth
                      <span class="required">*</span>
                    </label>
                    <kendo-datepicker class="form-control" id="DateOfBirth" name="DateOfBirth"
                      v-model="onBehalfModel.DateOfBirth" :format="'dd/MM/yyyy'"
                      :max="maxDate" @change="validateDateOfBirth($event)"
                      onkeydown="return false;" v-validate="'required'" data-vv-as='Date Of Birth'
                      :class="{'input': true, 'is-danger': errors.has('DateOfBirth') }" >
                    </kendo-datepicker>
                    <div v-show="errors.has('DateOfBirth')" class="help is-danger">
                      {{ errors.first('DateOfBirth') }}
                    </div>
                    <div v-show="isDateOfBirthInvalid" class="help is-danger">
                      Age should be at least 18 years. Please enter a valid Date of Birth.
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Country Of Birth
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="CountryOfBirthId" v-model="onBehalfModel.CountryOfBirthId"
                      data-vv-as="Country of Birth" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('CountryOfBirthId') }" @change="onChangeNationality">
                      <option :value="null" disabled>Select Country of Birth
                      </option>
                      <option :key="item.Id" v-for="item in BirthCountryList" :value="item.Id">{{item.Text}}
                      </option>
                    </select>
                    <div v-show="errors.has('CountryOfBirthId')" class="help is-danger">
                      {{ errors.first('CountryOfBirthId') }}</div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Gender
                      <span class="required">*</span>
                      </label>
                      <select class="form-control classic" name="Gender" v-model="onBehalfModel.Gender"
                      data-vv-as="Gender" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('Gender') }" @change="onChangeNationality">
                      <option :value="null" disabled>Select Gender
                      </option>
                      <option :key="item.Id" v-for="item in GenderList" :value="item.Id">{{item.Text}}
                      </option>
                    </select>
                    <div v-show="errors.has('Gender')" class="help is-danger">
                      {{ errors.first('Gender') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Country
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="CountryId" v-model="onBehalfModel.CountryId"
                      data-vv-as="Country" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('CountryId') }" @change="onChangeNationality">
                      <option :value="null" disabled>Select Country
                      </option>
                      <option :key="item.Id" v-for="item in CountryList" :value="item.Id">{{item.Text}}
                      </option>
                    </select>
                    <div v-show="errors.has('CountryId')" class="help is-danger">
                      {{ errors.first('CountryId') }}</div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Address
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="Address" name="Address"
                      autocomplete="off" v-model="onBehalfModel.Address" data-vv-as="Address"
                      :class="{'input': true, 'is-danger': errors.has('Address') }"
                      v-only-uppercase v-validate="'required'" />
                    <div v-show="errors.has('Address')" class="help is-danger">
                      {{ errors.first('Address') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Post Code
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="PostCode" name="PostCode"
                      autocomplete="off" v-model="onBehalfModel.PostCode" data-vv-as="Post Code"
                      :class="{'input': true, 'is-danger': errors.has('PostCode') }" v-validate="'required'"
                      v-only-uppercase />
                    <div v-show="errors.has('PostCode')" class="help is-danger">
                      {{ errors.first('PostCode') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      City
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="City" name="City"
                      autocomplete="off" v-model="onBehalfModel.City" data-vv-as="City"  v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('City') }"
                      v-only-uppercase />
                    <div v-show="errors.has('City')" class="help is-danger">
                      {{ errors.first('City') }}</div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="form-group">
                    <label for>
                      Province/Country/State
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="State" name="State"
                      autocomplete="off" v-model="onBehalfModel.State" data-vv-as="Province/Country/State"  v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('State') }"
                      v-only-uppercase />
                    <div v-show="errors.has('State')" class="help is-danger">
                      {{ errors.first('State') }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="onBehalfStep==2" class="row">
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for>
                      ID Type
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="IdTypeId" v-model="onBehalfModel.IdTypeId"
                      data-vv-as="ID Type" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('IdTypeId') }" @change="onChangeIdType">
                      <option :value="null" disabled>Select ID Type
                      </option>
                      <option :key="item.Id" v-for="item in IdTypeList" :value="item.Id">{{item.Text}}</option>
                    </select>
                    <div v-show="errors.has('IdTypeId')" class="help is-danger">
                      {{ errors.first('IdTypeId') }}</div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for>
                      ID Number
                      <span class="required">*</span>
                    </label>
                    <input type="text" class="form-control text-uppercase" id="IDNumber" name="IDNumber"
                      v-only-uppercase
                      v-validate="'required'"
                      autocomplete="off"
                      v-model="onBehalfModel.IdNumber"
                      data-vv-as="Id Number"
                      :class="{'input': true, 'is-danger': errors.has('IDNumber') }"
                      />
                    <div v-show="errors.has('IDNumber')" class="help is-danger">
                      {{ errors.first('IDNumber') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group">
                    <label for>
                      Relationship To Sender
                      <span class="required">*</span>
                    </label>
                    <select class="form-control classic" name="RelationshipToSender" id ="RelationshipToSender"
                      v-model="onBehalfModel.RelationshipId"
                      data-vv-as="Relationship To Sender" v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('RelationshipToSender') }" @change="onChangeIdType">
                      <option :value="null" disabled>Select Relationship
                      </option>
                      <option :key="item.Id" v-for="item in RelationshipList" :value="item.Id">{{item.Text}}</option>
                    </select>
                    <div v-show="errors.has('RelationshipToSender')" class="help is-danger">
                      {{ errors.first('RelationshipToSender') }}
                    </div>
                  </div>
                </div>
                <div class="col-lg-6" v-if="selectedIdType.IsFrontImageRequired">
                  <label>
                  ID Front
                      <span class="required" style="color:#c21c2b !important">*</span>
                    </label>
                    <div class="img-canvas">
                    <span class="img-icon-camera" v-if="!onBehalfModel.IdFrontImage"><i class="material-icons">photo_camera</i>
                    </span>
                    <span v-else><img :src="IdFrontImageForDisplay" alt=""></span>
                  </div>
                  <input type="hidden" class="form-control text-uppercase" id="IdFrontImage" name="IdFrontImage"
                    autocomplete="off"
                    :required = "selectedIdType.IsFrontImageRequired"
                    v-model="onBehalfModel.IdFrontImage" data-vv-as="ID Front Image"
                    :class="{'input': true, 'is-danger': errors.has('IdFrontImage') }" />
                  <div v-show="errors.has('FrontImage')" class="help is-danger">
                      {{ errors.first('FrontImage') }}
                  </div>
                  <div class="button-group file-button-wrapper">
                    <button type="button" class="btn btn-danger take-snap-button" @click="onOpenCamera('FRONT')">Take a
                      Picture</button>
                    <button type="button" class="btn btn-danger take-snap-button" @click="onUploadImage('FRONT')">Upload Image
                      </button>
                    <label for="FrontImage" style="display:none">
                      <div>Upload Image</div>
                      <input type="file" id="FrontImage" accept="image/png, image/jpeg" name="FrontImage" :require=false
                      data-vv-as = "Front Image" ref="uploadFrontImage" @change="onChangeFrontImage" v-validate="'required'"
                        :class="{'input': true, 'is-danger': errors.has('FrontImage')}">
                    </label>
                  </div>
                </div>
                <div class="col-lg-6" v-if="selectedIdType.IsBackImageRequired">
                  <label>
                  ID Back
                  <span class="required" style="color:#c21c2b !important">*</span>
                </label>
                  <div class="img-canvas">
                    <span class="img-icon-camera" v-if="!onBehalfModel.IdBackImage"><i class="material-icons">photo_camera</i>
                    </span>
                    <span v-else><img :src="IdBackImageForDisplay" alt=""></span>
                  </div>
                  <input type="hidden" class="form-control text-uppercase" id="IdBackImage" name="IdBackImage"
                    autocomplete="off"
                    :required = "selectedIdType.IsBackImageRequired"
                    v-model="onBehalfModel.IdBackImage" data-vv-as="ID Back Image"
                   :class="{'input': true, 'is-danger': errors.has('IdBackImage') }" />
                   <div v-show="errors.has('BackImage')" class="help is-danger">
                      {{ errors.first('BackImage') }}
                  </div>
                   <div class="button-group file-button-wrapper">
                    <button type="button" class="btn btn-danger take-snap-button" @click="onOpenCamera('BACK')">Take a
                      Picture</button>
                      <button type="button" class="btn btn-danger take-snap-button" @click="onUploadImage('BACK')">Upload Image
                      </button>
                    <label for="BackImage" style="display:none">
                      <div>Upload Image</div>
                      <input type="file" id="BackImage" accept="image/png, image/jpeg" name="BackImage"
                      ref="uploadBackImage" @change="onChangeBackImage" v-validate="'required'"
                      data-vv-as="Back Image" :class="{'input': true, 'is-danger': errors.has('BackImage')}">
                    <div v-show="errors.has('BackImage')" class="help is-danger">
                      {{ errors.first('BackImage') }}
                    </div>
                    </label>
                  </div>

                </div>
                <div class="col-lg-12">
                  <div class="col-lg-6">
                  <div class="round">
                    <input name="onBehalfDeclaration" id="onBehalfDeclaration"
                      data-vv-as="Please agree to terms and conditions to continue" v-validate="'required'"
                      type="checkbox" />
                    <label for="onBehalfDeclaration"></label>
                    <span class="pl-4">
                      I hearby declare that I am performing transaction(s) On behalf of the above name and confirm
                      that the information provided above is true and accurate.
                    </span>
                  </div>
                  </div>
                </div>
              </div>
              <div class="row onbehalf-add-button-row">
                <div class="col-lg-6">
                  <button type="button" class="btn btn-danger" @click="backFromOnBehalfAdd">BACK</button>
                </div>
                <div class="col-lg-6 save-button-wrapper">
                  <button v-if="onBehalfStep==1" type="submit" class="btn btn-danger">Next</button>
                  <button v-else type="submit" class="btn btn-danger">Save</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import CommonService from "../services/common";
  export default {
    name: "OnBehalfDetail",
    props: ["vModel"],
    data() {
      return {
        mode: 'Add',
        maxDate: new Date(),
        onBehalfStep:1,
        onBehalfModel: {
          FirstName:"",
          LastName:"",
          Name: null,
          NationalityId: null,
          IdTypeId: null,
          IdNumber: null,
          DateOfBirth: null,
          Address: null,
          MobileContact: null,
          OccupationId: null,
          WUOccupationId:null,
          EmployerName: null,
          IdFrontImage: null,
          IdBackImage: null,
          DialCodeId:4,
          PaymentNetworkId: 1

        },
        IdFrontImageForDisplay: null,
        IdBackImageForDisplay: null,
        MSSLCheck: {
          IsInMSSL: false,
          Message: null
        },
        OnbehalfCheck: {
			IsInValid: false,
			Title: null,
			Message: null
		},
        NationalityWithIdTypeList: [],
        IdTypeList: [],
        OccupationList: [],
        WUOccupationList:[],
        DialCodeList:[],
        isNotList: false,
        OccupationList:[],
        CountryList:[],
        GenderList: [],
        BirthCountryList: [],
        RelationshipList:[],
        selectedIdType: { IsFrontImageRequired: true },
        isCameraOpen: false,
        deviceId: null,
        isCameraForFrontImage: false,
        isCameraForBackImage: false,
        ShowEmploymentIndustry:false,
        EmploymentIndustries:[],
        isDateOfBirthInvalid:false,
        imageExtensionValidationMessage: "Please select .jpeg or .png or .tiff format to upload.",
        imageSizeValidationMessage: "File size must be lower then 500 KB."
      };
    },
    methods: {
      validateDateOfBirth:function(event){
        if(event == null || event == undefined){
          this.isDateOfBirthInvalid = true;
        }else{
          let pickedDate = event.sender.value();
          let date = new Date(pickedDate.getFullYear() + 18,
          pickedDate.getMonth(),
          pickedDate.getDate());
          if((new Date()).getDate() >= date.getDate()){
            this.isDateOfBirthInvalid = true;
          }
          else{
            this.isDateOfBirthInvalid = false;
          };
        }
        return;
      },
      onAddOnbehalfClick: function (onbehalfCustomerId) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.onProgress = true;
            switch(parseInt(this.vModel.PayoutModeId))
            {
              case 97:
                this.onBehalfModel.PaymentNetworkId = 2;
                break;
              case 98:
                this.onBehalfModel.PaymentNetworkId = 2;
                break;
              case 101:
              case 102:
                this.onBehalfModel.PaymentNetworkId = 3;
                break;
              default:
                this.onBehalfModel.PaymentNetworkId = 1;
                break;
            }

            this.$http
              .get("v2/onbehalf/customer/init/" + this.onBehalfModel.PaymentNetworkId)
              .then(
                (response) => {
                  this.NationalityWithIdTypeList = response.body.NationalityWithIdTypeList;
                  this.OccupationList = response.body.OccupationList;
                  this.WUOccupationList = response.body.WUOccupationList
                  this.DialCodeList = response.body.DialCodeList
                  this.CountryList = response.body.CountryList;
                  this.GenderList = response.body.GenderList;
                  this.BirthCountryList = response.body.BirthCountryList;
                  this.RelationshipList = response.body.RelationshipList;
                  this.isNotList = true;
                  this.onProgress = false;
                },
                (error) => {
                  this.onProgress = false;
                }
            );
            if (onbehalfCustomerId != null && onbehalfCustomerId != 'undefined') {
                this.mode = 'Edit';
				this.$http.get("v3/onbehalf/customer/init/" + onbehalfCustomerId)
                    .then(
                        (response) => {
                            this.onBehalfModel = response.body.OnBehalfCustomerDetail
                            if (this.onBehalfModel.NationalityId) {
                                this.IdTypeList = this.NationalityWithIdTypeList.filter(x => {
                                    return x.Id == this.onBehalfModel.NationalityId
                                })[0].IdTypes;
                            }
                        },
                        (error) => {

                        }
                    );
            }
          }
        });
      },

      onChangeNationality: function () {
        this.onBehalfModel.IdTypeId = null;
        this.onBehalfModel.IdFrontImage = null;
        this.IdFrontImageForDisplay = null;
        this.onBehalfModel.IdBackImage = null;
        this.IdBackImageForDisplay = null;
        this.selectedIdType = { IsFrontImageRequired: true };
        this.IdTypeList = [];
        if (this.onBehalfModel.NationalityId) {
          this.IdTypeList = this.NationalityWithIdTypeList.filter(x => {
            return x.Id == this.onBehalfModel.NationalityId
          })[0].IdTypes;
        }
      },

      onChangeIdType: function () {
        this.onBehalfModel.IdFrontImage = null;
        this.IdFrontImageForDisplay = null;
        this.onBehalfModel.IdBackImage = null;
        this.IdBackImageForDisplay = null;
        this.selectedIdType = { IsFrontImageRequired: true };
        if (this.onBehalfModel.IdTypeId) {
          this.selectedIdType = this.IdTypeList.filter(x => {
            return x.Id == this.onBehalfModel.IdTypeId
          })[0];
        }
      },
		onSelectOnBehalfCustomer: function (onBehalfCustomerId) {
			var self = this;
			self.$http.get("v2/onbehalf/isdetailsvalidate/" + onBehalfCustomerId).then(
				resp => {
					if (resp.body.IsDetailsValid == false) {
						self.OnbehalfCheck.IsInValid = true;
						self.OnbehalfCheck.Title = resp.body.Title;
						self.OnbehalfCheck.Message = resp.body.Message;
					}
					else {
						self.vModel.OnBehalfDetail = self.vModel.OnBehalfList.filter(
							(s) => {
								return s.OnBehalfCustomerId == onBehalfCustomerId;
							}
						)[0];

						self.vModel.isOnBehalfTransaction = true;
						setTimeout(() => {
							self.vModel.onBehalfDecisionCheck.ShowOnbehalfList = false;
						}, 1000);
					}
				})

		},

      onDeleteOnBehalfCustomer: function (onBehalfCustomerId) {
        var self = this;
        kendo.confirm("Are you sure you want to delete beneficial owner?").then(() => {
          self.onProgress = true;
          self.$http
            .post("onbehalf/customer/delete", { OnBehalfCustomerId: onBehalfCustomerId })
            .then(
              (response) => {
                self.vModel.OnBehalfList = self.vModel.OnBehalfList.filter(
                  (s) => {
                    return s.OnBehalfCustomerId != onBehalfCustomerId;
                  }
                )
                self.$toastr("success", "Beneficial Owner Deleted Successfully");
                self.onProgress = false;
              },
              (error) => {
                self.onProgress = false;
              }
            );
        })
      },
      onSubmitOnBehalf: function () {
        if(this.isDateOfBirthInvalid){
          return;
        }
        var self = this;

        self.$validator.validateAll().then((result) => {
          if (result) {
            self.onProgress = true;
            var cloneModel = {...self.onBehalfModel};
            cloneModel.DateOfBirth = CommonService.ToYYYYMMDD(
              cloneModel.DateOfBirth
            );

            if(this.onBehalfStep==1 && this.onBehalfModel.PaymentNetworkId == 2){
              this.onBehalfStep=2
              return;
            }
            cloneModel.Name = cloneModel.Name || cloneModel.FirstName+' '+cloneModel.LastName;
            var model = {
              Name: cloneModel.Name,
              IdNumber: cloneModel.IdNumber,
              DateOfBirth : cloneModel.DateOfBirth,
              NationalityId : cloneModel.NationalityId,
              MobileContact : cloneModel.MobileContact,
            };

            self.$http.post("onbehalf/customer/check/mssl", model).then(
              resp => {
                if (!resp.body.IsInMSSL) {
                  self.$http
                    .post("onbehalf/customer/save", cloneModel)
                    .then(
                      (response) => {
                        self.vModel.OnBehalfDetail = response.body;
                        self.$toastr("success", "Beneficial Owner Saved Successfully");
                        self.vModel.isOnBehalfTransaction = true;
                        setTimeout(() => {
                          self.vModel.onBehalfDecisionCheck.ShowOnbehalfList = false;
                        }, 1000);
                      },
                      (error) => {
                        self.onProgress = false;
                      }
                    );
                } else {
                  self.MSSLCheck.IsInMSSL = resp.body.IsInMSSL;
                  self.MSSLCheck.Message = resp.body.Message;
                }
              }

            )
          } else {
            if (self.errors.has("onBehalfDeclaration")) {
              kendo.alert(
                "Please check the declaration"
              );
              return false;
            }
          }
        });
      },
    //FILE FROM GALLERY
    onChangeFrontImage: function (e) {
      this.selectedFile = e.target.files[0];
      if (this.imageValidation()) {
        this.$refs.uploadFrontImage.value = null;
        this.IdFrontImageForDisplay = null;
        this.onBehalfModel.IdFrontImage = null;
        return;
        }

      var self = this;
      const reader = new FileReader();
      reader.onloadend = function (e) {
        self.onBehalfModel.IdFrontImage = this.result.split(',')[1];
        self.IdFrontImageForDisplay = this.result;
      };
      reader.readAsDataURL(this.selectedFile);
    },
    onChangeBackImage: function (e) {
      this.selectedFile = e.target.files[0];

      if (this.imageValidation()) {
        this.$refs.uploadBackImage.value = null;
        this.IdBackImageForDisplay = null;
        this.onBehalfModel.IdBackImage = null;
        return;
      }
      var self = this;
      const reader = new FileReader();
      reader.onloadend = function (e) {
        self.onBehalfModel.IdBackImage = this.result.split(',')[1];
        self.IdBackImageForDisplay = this.result;
      };
      reader.readAsDataURL(this.selectedFile);
    },
    alertImageValidationMessage: function (fileSize, fileType) {
      var message = "";
      if (fileSize || fileType) {
        if (fileType) {
          message = message + this.imageExtensionValidationMessage + "\n";
        }
        if (fileSize) {
          message = message + this.imageSizeValidationMessage;
        }
      }
      if (message != "") {
        kendo.alert(message)
      }
    },
    imageValidation: function () {
      let _validFileExtensions = ["png", "jpeg", "tiff"];
      this.fileName = this.selectedFile.name;
      let fileSize = this.selectedFile.size;
      let dotSplittedFileName = this.fileName.split('.');
      let extension = dotSplittedFileName[dotSplittedFileName.length - 1];
      let isExtensionInValid = false;
      let isFileSizeInValid = false;

      let index = _validFileExtensions.findIndex(x => x == extension.toLowerCase())
      if(index === -1 ){
        isExtensionInValid = true;
      }
      if (extension.toLowerCase() === 'mp4') {
        isExtensionInValid = true;
      }
      if ((fileSize / 1024) > 500) {
        isFileSizeInValid = true;
      }
      this.alertImageValidationMessage(isFileSizeInValid, isExtensionInValid)
      return isExtensionInValid || isFileSizeInValid;

    },
      //
      //WEBCAM RELATED METHODS
      onTakeSnapshot: function () {
        if (this.isCameraOpen && this.isCameraForFrontImage) {
          this.IdFrontImageForDisplay = this.$refs.webcam.capture();
          let fileSize = (new Blob([this.IdFrontImageForDisplay])).size;
          if((fileSize/1024) > 500){
            kendo.alert("File size must be lower then 500 KB.");
            return false;
          }
          this.onBehalfModel.IdFrontImage = this.IdFrontImageForDisplay.split(',')[1];

        } else if (this.isCameraOpen && this.isCameraForBackImage) {
          this.IdBackImageForDisplay = this.$refs.webcam.capture();
          let fileSize = (new Blob([this.IdFrontImageForDisplay])).size;
          if((fileSize/1024) > 500){
            kendo.alert("File size must be lower then 500 KB.");
            return false;
          }
          this.onBehalfModel.IdBackImage = this.IdBackImageForDisplay.split(',')[1];
        }
        this.isCameraOpen = false;
      },
      onOpenCamera: function (cameraFor) {
        var self = this;
        kendo.confirm("eRemit would like to access camera and photos !!").then(function(){
          if (cameraFor == "FRONT") {
          self.isCameraForFrontImage = true;
          self.isCameraForBackImage = false;
        }
        else {
          self.isCameraForFrontImage = false;
          self.isCameraForBackImage = true;
        }

        self.isCameraOpen = true;
        setTimeout(() => {
          self.$refs.webcam.start();
        }, 100);
        }, function(cancel){
        });

      },

      onCameras(cameras) {
        this.devices = cameras;
        if (cameras && cameras.length > 0) this.deviceId = cameras[0].deviceId;
        else
          kendo.alert("Camera not detected.");
      },
      onError(error) {
        var errorMsg = '';
        if (error && error.message == "Permission denied")
          errorMsg = `${error.message}. Please enable camera from browser setting.`;
          else
        errorMsg = error.message;
        this.isCameraOpen = false;
        kendo.alert(errorMsg);
      },
      //
      handleOk: function () {
        this.$router.push("/dashboard");
      },
      backFromOnBehalfList: function () {
        var self = this;
        self.vModel.isOnBehalfTransaction = false;
        setTimeout(() => {
          self.vModel.onBehalfDecisionCheck.ShowOnbehalfList = false;
        }, 200);
      },
      backFromOnBehalfAdd: function () {
        if(this.onBehalfStep==2 && this.onBehalfModel.PaymentNetworkId == 2){
              this.onBehalfStep=1
              return;
            }
        this.isNotList = false;
      },
      onUploadImage: function(imageFor) {
        var self = this;
        kendo.confirm("eRemit would like to access media/photo !!").then(function(){
          if(imageFor == "FRONT"){
            self.$refs.uploadFrontImage.click();
          } else {
             self.$refs.uploadBackImage.click();
          }
        },
        function(cancel){
        });
      },
      onWUOccupationChange(e){
        if (this.onBehalfModel.WUOccupationId) {
          var occupation = this.WUOccupationList.filter((s) => {
            return s.Id == this.onBehalfModel.WUOccupationId;
          })[0];
          this.EmploymentIndustries = occupation.EmploymentIndustries;
          this.ShowEmploymentIndustry = occupation.ShowEmploymentIndustry
        }
      },
      closeModal() {
	    this.OnbehalfCheck.IsInValid = false;
      }
    }
  };
</script>
